import React, { Component } from 'react';
import envStatic from '../../../envStatic';
import { getUserId, getUserFactoryId } from '../../../index';
import { BIRender } from '../../components/PowerBIRender/BIRender';

class SupervisorPage extends Component {

    render() {
        const userId = getUserId();
        const userFactory = getUserFactoryId();
        return (<BIRender filters={`&filter=factories/id eq ${userFactory} and users/user_direct_superior_id eq ${userId} and training_users/users_user_direct_superior_id eq ${userId}`} reportSection={envStatic.reportSectionSupervisor} />)
    }
}

export default SupervisorPage